/* Set the actual numeric facets before Sparq creates its store. */
(() => {
  const filters = window.sq?.config?.filters;
  if (!Array.isArray(filters)) return;
  const discount = filters.find(filter => filter.stFieldName === 'discount');
  if (!discount) return;
  discount.ranges = [[0,10],[11,20],[21,30],[31,40],[41,50],[51,100]].map(([min,max], index) => ({ min, max, displayOrder:index + 1 }));
})();
